import React from 'react';
import Grid from '@mui/material/Grid';
import { IAdminAccount } from '../../api/admin';
import { formatDate } from '../../utils/dates';
import { accountSummary, statusLabel, statusTextColor } from './AccountStatusChip';
import { KEY_DATE_LABEL, money } from './AccountsTable';
import StatTile from './StatTile';
import { LastTouchpointTile } from './TaskTrailPanel';

interface Props {
	accountId: number;
	account: IAdminAccount | undefined;
	loading?: boolean;
}

/** What a sales person checks first: status, key date, last touchpoint, seats in use, value. */
export default function AccountStatTiles({ accountId, account, loading }: Props) {
	const TILE = 2.4;
	const over = !!account && account.seats != null && account.seats_active > account.seats;
	const paid = !!account && account.value != null && account.value > 0;

	return (
		<Grid container spacing={2.5} sx={{ mb: 2.5 }}>
			<Grid item xs={6} sm={TILE}>
				<StatTile
					label="Status"
					value={account ? statusLabel(account.status) : null}
					caption={account ? accountSummary(account) : undefined}
					valueColor={account ? statusTextColor(account.status) : undefined}
					loading={loading}
				/>
			</Grid>
			<Grid item xs={6} sm={TILE}>
				<StatTile
					label="Key date"
					value={account?.key_date ? formatDate(account.key_date) : null}
					caption={account?.key_date_kind ? KEY_DATE_LABEL[account.key_date_kind] : 'no date set'}
					loading={loading}
				/>
			</Grid>
			<Grid item xs={6} sm={TILE}>
				<LastTouchpointTile subject={{ accountId }} />
			</Grid>
			<Grid item xs={6} sm={TILE}>
				<StatTile
					label="Seats active"
					value={account?.seats_active ?? null}
					caption={account ? (account.seats != null ? `of ${account.seats} seats` : 'no seat limit') : undefined}
					secondary={over ? 'over the seat limit' : undefined}
					valueColor={over ? 'error.main' : undefined}
					loading={loading}
				/>
			</Grid>
			<Grid item xs={6} sm={TILE}>
				<StatTile
					label="Value"
					value={account ? (paid ? money(account.value) : 'Free') : null}
					caption={account ? (paid ? 'Paid · total for the term' : 'no charge') : undefined}
					loading={loading}
				/>
			</Grid>
		</Grid>
	);
}
